export class User {
  id: number;
  identification: string;
  name: string;
  last_name: string;
  email: string;
  token?: string;
  agent_id?: number;
  photo: string;
  role: string;
  agent_operation: unknown;
  password_updated_at: boolean;

  constructor(obj?) {
    this.id = obj.id;
    this.identification = obj.identification;
    this.name = obj.name;
    this.last_name = obj.last_name;
    this.email = obj.email;
    this.agent_id = obj.agent_id;
    if (obj.token) {
      this.token = obj.token;
    }

    this.agent_operation = obj.agent_operation ? obj.agent_operation : null;
    // this.role = obj.age,
    this.photo = obj.photo ? obj.photo : null;
    this.password_updated_at = obj.password_updated_at;
  }
}
